module.exports = __webpack_public_path__ + "static/media/healthy-breakfast600.6d769e4c.jpeg";